import { render } from "./TheNavigation.vue?vue&type=template&id=4e31fbf9"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"

import "./TheNavigation.vue?vue&type=style&index=0&id=4e31fbf9&lang=scss"

import exportComponent from "/Users/giulio/Documents/Sviluppo/chen/categoria/test-pwa-serverless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__